import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useAddMemberToChat = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["add_member"],
    mutationFn: async (query) => {
      return await axios.post("/chat/addmember", query);
    },
  });
};